/**
 * Mappers for role assigned employees list operations
 */

import type {
  LC_RoleAssignedEmployee,
  LC_RoleAssignedEmployeesListOut,
  RoleAssignedEmployee,
  RoleAssignedEmployeesListResult,
} from './roleAssignedEmployees.types';


export function mapRoleAssignedEmployeeToModel(
  transport: LC_RoleAssignedEmployee,
): RoleAssignedEmployee {
  return {
    rut: transport.employeeTaxIdentificationNumber ?? '',
    name: (transport.employeeName ?? '').trim(),
    webRolesCount: transport.webRolesCount,
    mobileRolesCount: transport.mobileRolesCount,
    webRoleNames: transport.webRoleNames ?? [],
    mobileRoleNames: transport.mobileRoleNames ?? [],
    status: transport.status,
  };
}

export function mapRoleAssignedEmployeesListResultToModel(
  transport: LC_RoleAssignedEmployeesListOut,
): RoleAssignedEmployeesListResult {
  return {
    items: transport.data ? transport.data.map(mapRoleAssignedEmployeeToModel) : [],
    totalRecords: transport.pagination.totalRecords,
  };
}
